<template>
  <transition name="login-overlay-fade">
    <div
      v-if="loginGate.visible"
      class="login-overlay-root fixed inset-0 z-[10050] flex items-center justify-center overflow-y-auto p-3 py-8"
      role="dialog"
      aria-modal="true"
      aria-label="登录"
    >
      <div class="absolute inset-0 bg-black/72 backdrop-blur-[10px]" @click="onBackdropClick" />
      <div class="relative z-10 my-auto max-w-[720px]" @click.stop><!-- w-full -->
        <LoginFormCard overlay-mode @close="onClose" @success="onSuccess" />
      </div>
    </div>
  </transition>
</template>

<script>
import LoginFormCard from './LoginFormCard.vue'
import { loginGate, closeLoginModal, hasAuthToken } from '../utils/loginGate'

export default {
  name: 'LoginOverlay',
  components: { LoginFormCard },
  data() {
    return { loginGate }
  },
  watch: {
    'loginGate.visible'(v) {
      if (typeof document === 'undefined') return
      document.body.style.overflow = v ? 'hidden' : ''
      if (v && hasAuthToken()) {
        closeLoginModal()
      }
    }
  },
  mounted() {
    if (this.loginGate.visible) document.body.style.overflow = 'hidden'
  },
  beforeDestroy() {
    document.body.style.overflow = ''
  },
  methods: {
    onBackdropClick() {
      this.onClose()
    },
    onClose() {
      closeLoginModal()
      const token = hasAuthToken()
      if (!token && this.$route.meta && this.$route.meta.requiresAuth) {
        this.$router.replace('/')
      }
    },
    onSuccess() {
      closeLoginModal()
    }
  }
}
</script>

<style scoped>
.login-overlay-fade-enter-active,
.login-overlay-fade-leave-active {
  transition: opacity 0.2s ease;
}
.login-overlay-fade-enter,
.login-overlay-fade-leave-to {
  opacity: 0;
}
</style>
